module.exports = __webpack_public_path__ + "videos/pleated-blinds-video.e60c01c.webm";